import { render, staticRenderFns } from "./order.vue?vue&type=template&id=e37b14c0&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=e37b14c0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37b14c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37b14c0')) {
      api.createRecord('e37b14c0', component.options)
    } else {
      api.reload('e37b14c0', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=e37b14c0&scoped=true", function () {
      api.rerender('e37b14c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/directly_order_receive/components/order.vue"
export default component.exports